"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classNames_1 = require("@helpscout/react-utils/dist/classNames");

var arrays_1 = require("./arrays");
/**
 * Tiny implementation of the classnames library.
 *
 * @param   {any} classes
 * @returns {string}
 */


exports.classNames = classNames_1.default;
/**
 * Generate className variations.
 *
 * @param   {string} className
 * @param   {string} variation
 * @returns {string}
 */

exports.variantClassNames = function (className, variant) {
  if (variant === void 0) {
    variant = '';
  }

  if (typeof className !== 'string' || !className.length) return '';
  if (variant && typeof variant !== 'string') return className;
  return variant.trim().split(/[ ,]+/).map(function (o) {
    return className + "-" + o;
  }).join(' ');
};
/**
 * Used with classNames generated by a Fancy styled-component.
 * Fancy (Emotion) appends the hashed className at the very end.
 * This function plucks it out and returns it.
 *
 * @param   {string} classNames
 * @returns {string}
 */


exports.getHashedClassName = function (classNames) {
  return arrays_1.last(classNames.split(' '));
};
/**
 * Convenience class for generating BEM style classNames, based on a block.
 */


var BEMClass =
/** @class */
function () {
  function BEMClass(block) {
    this.block = '';
    this.block = block;
  }
  /**
   * Generates a BEM element className
   *
   * @param   {string} element
   * @returns {string}
   */


  BEMClass.prototype.element = function (element) {
    return this.block + "__" + element;
  };
  /**
   * Alias for BEM.element
   *
   * @param   {string} element
   * @returns {string}
   */


  BEMClass.prototype.e = function (element) {
    return this.element(element);
  };
  /**
   * Generates a BEM modifer className
   *
   * @param   {string} element
   * @returns {string}
   */


  BEMClass.prototype.modifier = function (modifier) {
    return this.block + "--" + modifier;
  };
  /**
   * Alias for BEM.modifer
   *
   * @param   {string} element
   * @returns {string}
   */


  BEMClass.prototype.m = function (modifier) {
    return this.modifier(modifier);
  };

  return BEMClass;
}();
/**
 * Used with classNames generated by a Fancy styled-component, combined
 * with a BEM styled __element suffix.
 *
 * @param   {string} classNames
 * @param   {string} suffix
 * @returns {string}
 */


exports.BEM = function (classNames) {
  return new BEMClass(exports.getHashedClassName(classNames));
};

exports.default = exports.classNames;